// HoneyBook lead form widget placement ID
export const HONEYBOOK_PID = "6aa9aa9847cb24c594ecfcfd";

export const NAV_LINKS = [
  { to: "/work", label: "Work" },
  { to: "/for-businesses", label: "Video & Content" },
  { to: "/marketing", label: "Marketing" },
  { to: "/branding", label: "Branding" },
  { to: "/systems", label: "Studio Builds" },
  { to: "/live-production", label: "Production" },
  { to: "/s3-films", label: "S3 Films" },
];

const U = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;

export const IMAGES = {
  heroRig: U("photo-1485846234645-a62644f84728"),
  console: U("photo-1598488035139-bdbb2231ce04"),
  stage: U("photo-1429962714451-bb934ecdc4ec"),
  concert: U("photo-1470229722913-7c0e2dbbafd3"),
  crowd: U("photo-1533174072545-7a4b6ad7a6c3"),
  wedding: U("photo-1519741497674-611481863552"),
  sparklers: U("photo-1511285560929-80b456fea0bc"),
  ceremony: U("photo-1465495976277-4387d4b0b4c6"),
  podcast: U("photo-1590602847861-f357a9332bbc"),
  meeting: U("photo-1556761175-b413da4baf72"),
  church: U("photo-1438232992991-995b7058bbb3"),
  edit: U("photo-1574717024653-61fd2cf4d44d"),
  camera: U("photo-1492691527719-9d1e07e534b4"),
  drone: U("photo-1473968512647-3e447244af8f"),
  mic: U("photo-1511671782779-c97d3d27a1d4"),
  guitar: U("photo-1493225457124-a3eb161ffa5f"),
  branding: U("photo-1561070791-2526d30994b5"),
  brandingStudio: U("photo-1626785774573-4b799315345d"),
  marketing: U("photo-1460925895917-afdab827c52f"),
  social: U("photo-1611926653458-09294b3142bf"),
  product: U("photo-1523275335684-37898b6baf30"),
  coffee: U("photo-1495474472287-4d71bcdd2085"),
  interview: U("photo-1557804506-669a67965ba0"),
  web: U("photo-1547658719-da2b51169166"),
  saraCalvinKiss: "/assets/media/sara-calvin-kiss.jpg",
  saraCalvinBW: "/assets/media/sara-calvin-bw.jpg",
  saraCalvinFront: "/assets/media/sara-calvin-front.jpg",
  soundCheck: "/assets/media/sound-check.jpg",
  studioAudio: "/assets/media/studio-audio.jpg",
  ssBanner: "/assets/media/ss-banner.jpg",
};

export const VIDEOS = {
  showcase: "/assets/media/work-showcase-loop.mp4",
  wedding: "/assets/media/wedding-sara-calvin.mp4",
  livestream: "/assets/media/lcc-livestream.mp4",
  concerts: "/assets/media/concerts.mp4",
  aci: "/assets/media/aci-training.mp4",
  drj: "/assets/media/drj-grocery-reel.mp4",
};

export const PROJECTS = [
  {
    id: "bg-ben-giles",
    title: "BG — Big Guy Ben Giles Review",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-bg.jpg",
    video: "/assets/media/v-bg.mp4",
    poster: "/assets/media/p-bg.jpg",
    tags: ["S3 Films", "Event Coverage", "Show Review"],
    summary:
      "Our flagship review coverage for Big Guy Ben Giles — big energy, fast turnarounds, and edits built to be shared.",
    challenge:
      "Live reviews move fast — capture the energy of the room without missing the moment that matters.",
    approach:
      "Multi-angle coverage, quick-cut edits, and audio that puts the viewer right back in the room.",
    outcome:
      "One of our most-shared videos to date — the kind of work that books the next show.",
    metrics: ["Same-week edit", "Multi-cam coverage", "Fan favorite"],
  },
  {
    id: "engagement-party",
    title: "The Engagement Party",
    category: "Video",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/p-engagement.jpg",
    video: "/assets/media/v-engagement.mp4",
    poster: "/assets/media/p-engagement.jpg",
    tags: ["S3 Films", "Event Film", "Cinematic"],
    summary:
      "An engagement party filmed like the opening chapter of a wedding story.",
    challenge:
      "One evening, no retakes — the speeches and reactions happen once.",
    approach:
      "Documentary coverage with cinematic portraits woven between the moments.",
    outcome:
      "A film the couple gets to keep from the very first celebration of the story.",
    metrics: ["One evening", "Cinematic cut", "S3 Films"],
  },
  {
    id: "wedding-highlights",
    title: "Wedding Highlights — Social Cut",
    category: "Social",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/p-wedding-highlight.jpg",
    video: "/assets/media/v-wedding-highlight.mp4",
    poster: "/assets/media/p-wedding-highlight.jpg",
    tags: ["S3 Films", "Vertical", "Post-Ready"],
    summary:
      "A vertical, posting-ready highlight cut built from a wedding's most cinematic frames.",
    challenge:
      "Condense the best day of someone's life into sixty seconds without losing the feeling.",
    approach:
      "Vertical-first framing and a hook in the first three seconds.",
    outcome:
      "Feed-ready the same week — shared while the excitement is still fresh.",
    metrics: ["Vertical format", "60-second cut", "Post-ready"],
  },
  {
    id: "interview-studio-build",
    title: "The Interview Studio — Turnkey Build",
    category: "Studio Builds",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/studio-b.jpg",
    tags: ["Studio Build", "Multi-Cam", "Lighting Grid"],
    summary:
      "A turnkey interview and podcast studio — multi-camera rig, overhead lighting grid, and a set that looks like a show.",
    challenge:
      "A room that had to look broadcast-ready on camera and run without a crew.",
    approach:
      "Set design, camera and lighting placement, and a workflow the hosts can run themselves.",
    outcome:
      "A studio that produces a professional show every single week.",
    metrics: ["Multi-cam rig", "Lighting grid", "Crew-free workflow"],
  },
  {
    id: "blue-line-tavern",
    title: "Blue Line Tavern × I Love Fond du Lac",
    category: "Marketing",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-blueline1.jpg",
    video: "/assets/media/v-blueline1.mp4",
    poster: "/assets/media/p-blueline1.jpg",
    tags: ["Monthly Retainer", "Story Video", "Ongoing Content"],
    summary:
      "A monthly content retainer with Kristin and the I Love Fond du Lac group — spotlighting the local downtown businesses she features, like Blue Line Tavern.",
    challenge:
      "Downtown Fond du Lac is full of businesses worth talking about — but without a steady content rhythm, each one slips out of the feed by Friday.",
    approach:
      "A recurring monthly rhythm with Kristin and the I Love Fond du Lac group: we show up at each featured downtown business, find the story, and deliver ready-to-post video.",
    outcome:
      "Consistent local storytelling that keeps downtown Fond du Lac's businesses — taverns, shops, and everything in between — in the feed and in the conversation.",
    metrics: ["Monthly retainer", "Ongoing series", "Local reach"],
  },
  {
    id: "smart-frame",
    title: "Smart Frame — Product Showcase",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-smartframe.jpg",
    video: "/assets/media/v-smartframe.mp4",
    poster: "/assets/media/p-smartframe.jpg",
    tags: ["Product Video", "3D / CAD", "24-Hour Turnaround"],
    summary:
      "A patented smart-frame for security doors, showcased for TechzZ and Accurate Controls — filmed, edited, and 3D-modeled in a single day.",
    challenge:
      "Brand-new patented technology that needed to look revolutionary — by tomorrow.",
    approach:
      "A one-day sprint: product filming, a CAD and Blender 3D rendition, and a finished cut within 24 hours.",
    outcome:
      "A showcase the client took straight to market.",
    metrics: ["24-hour turnaround", "3D + live action", "Patent showcase"],
  },
  {
    id: "accurate-controls",
    title: "Accurate Controls — Executive Portraits",
    category: "Photography",
    location: "Ripon, WI",
    year: "2026",
    image: "/assets/media/hs-1.jpg",
    gallery: [
      "/assets/media/hs-1.jpg",
      "/assets/media/hs-2.jpg",
      "/assets/media/hs-3.jpg",
      "/assets/media/hs-4.jpg",
      "/assets/media/hs-5.jpg",
      "/assets/media/hs-6.jpg",
    ],
    tags: ["Headshots", "Executive Portraits", "On-Location"],
    summary:
      "Professional headshots for Accurate Controls Inc., featuring CEO TJ Rogers — clean, confident, and shot on location.",
    challenge:
      "Executive portraits that feel modern rather than stiff — captured at their Ripon facility.",
    approach:
      "Controlled lighting on location with a consistent look across the entire session.",
    outcome:
      "A portrait set the company uses across web, press, and proposals.",
    metrics: ["On-location", "Consistent look", "Web + press ready"],
  },
  {
    id: "sara-calvin-wedding",
    title: "Sara & Calvin — The Wedding Film",
    category: "Video",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/sara-calvin-kiss.jpg",
    video: "/assets/media/wedding-sara-calvin.mp4",
    poster: "/assets/media/poster-wedding.jpg",
    tags: ["S3 Films", "Wedding Film", "Feature Film"],
    summary:
      "A full wedding day captured by S3 Films — ceremony to dance floor, cut as a cinematic feature film.",
    challenge:
      "A couple who wanted the day documented honestly — the nerves, the vows, the toasts — without turning the wedding into a production set.",
    approach:
      "Small footprint, real audio from the ceremony and speeches, and a feature edit built around the moments that actually mattered.",
    outcome:
      "A feature film the family will watch on anniversaries — the kind of work S3 Films is named for: Story. Scene. Sound.",
    metrics: ["Feature film", "Full-day coverage", "S3 Films"],
  },
  {
    id: "passenger-lounge",
    title: "The Passenger Lounge × Wonderfunk",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-passenger.jpg",
    video: "/assets/media/v-passenger.mp4",
    poster: "/assets/media/p-passenger.jpg",
    tags: ["S3 Films", "Promo", "Live Music"],
    summary:
      "A high-energy promo for The Passenger Lounge featuring Wonderfunk — venue, band, and crowd in one cut.",
    challenge:
      "Capture a venue's entire vibe in ninety seconds.",
    approach:
      "Live performance coverage cut tight against the track — no filler, all feeling.",
    outcome:
      "A promo both the venue and the band use to book what's next.",
    metrics: ["Venue promo", "Live performance", "Shared asset"],
  },
  {
    id: "podcast-studio-build",
    title: "The Podcast Lounge — Studio Build",
    category: "Studio Builds",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/studio-a.jpg",
    tags: ["Studio Build", "Podcast", "Set Design"],
    summary:
      "A brick-walled podcast lounge built for conversation — lit once, mic'd always, ready when the hosts are.",
    challenge:
      "Turn an ordinary room into a space that feels like a show people want to watch.",
    approach:
      "Set design, permanent lighting, and a camera and audio layout tuned to the room.",
    outcome:
      "A room where hitting record is the easiest part of the day.",
    metrics: ["Permanent setup", "Tuned lighting", "Walk-in ready"],
  },
  {
    id: "lcc-livestream",
    title: "LCC Livestream Production",
    category: "Events",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/poster-lcc.jpg",
    video: "/assets/media/lcc-livestream.mp4",
    poster: "/assets/media/poster-lcc.jpg",
    tags: ["Livestream", "Multi-Cam", "Event Production"],
    summary:
      "Recurring livestream production — multi-camera switching, broadcast graphics, and a stream the audience can count on every week.",
    challenge:
      "A live program that needed broadcast polish every single week — with no room for stream drops or missed cues.",
    approach:
      "A multi-camera package with dedicated graphics, clean program audio, and a transition system built in-house.",
    outcome:
      "A stream that runs like clockwork — professional enough that viewers forget it's produced by a local team.",
    metrics: ["Multi-cam switch", "Broadcast graphics", "Recurring production"],
  },
  {
    id: "concert-production",
    title: "Concert Production Highlights",
    category: "Events",
    location: "Wisconsin",
    year: "2025",
    image: "/assets/media/poster-concerts.jpg",
    video: "/assets/media/concerts.mp4",
    poster: "/assets/media/poster-concerts.jpg",
    tags: ["Live Sound", "Lighting", "Live Events"],
    summary:
      "Live sound and lighting for concert events — the technical arm of Studio Solutions, on stage.",
    challenge:
      "Live shows leave no room for second takes — the mix, the lights, and the changeovers all have to land.",
    approach:
      "Pre-planned input lists, scenes programmed per set, and a crew that treats every show like a broadcast.",
    outcome:
      "Shows that sound as good as they look — captured here in our concert highlight reel.",
    metrics: ["Live sound", "Lighting design", "Highlight reel"],
  },
  {
    id: "aci-training",
    title: "ACI Training Series",
    category: "Video",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/poster-aci.jpg",
    video: "/assets/media/aci-training.mp4",
    poster: "/assets/media/poster-aci.jpg",
    tags: ["Corporate Video", "Training Content", "Post-Production"],
    summary:
      "A training video series for a corporate client — scripted, filmed, and edited for internal rollout.",
    challenge:
      "Dense material that needed to be watchable — and consistent across a full series.",
    approach:
      "A repeatable set look, clean audio, and graphics that carry the key points.",
    outcome:
      "A training library the client reuses for every new hire.",
    metrics: ["Series format", "Reusable library", "Script to screen"],
  },
  {
    id: "drj-grocery-reel",
    title: "Dr. J's Grocery — Social Reel",
    category: "Social",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/poster-drj.jpg",
    video: "/assets/media/drj-grocery-reel.mp4",
    poster: "/assets/media/poster-drj.jpg",
    tags: ["Short-Form", "Social Content", "Reel"],
    summary:
      "A short-form reel for a local grocery brand — fast, vertical, and built for the feed.",
    challenge:
      "Make a grocery stop feel worth watching in under a minute.",
    approach:
      "Quick-cut vertical filming with product moments and a hook in the first three seconds.",
    outcome:
      "Feed-ready content the brand can post the same week.",
    metrics: ["Vertical reel", "Same-week delivery", "Feed-ready"],
  },
  {
    id: "derangement-music-video",
    title: "Derangement — Music Video",
    category: "Video",
    location: "Fond du Lac & Madison, WI",
    year: "2026",
    image: "/assets/media/p-music-video.jpg",
    video: "/assets/media/v-music-video.mp4",
    poster: "/assets/media/p-music-video.jpg",
    tags: ["S3 Films", "Music Video", "Narrative"],
    summary:
      "A full music video production for a local artist — concept to final grade across Fond du Lac and Madison.",
    challenge:
      "Translate a track into images that feel as loud as the song.",
    approach:
      "Narrative concept, multi-location shoot, and a grade that matches the record's mood.",
    outcome:
      "A release-ready video the artist leads with everywhere.",
    metrics: ["Full production", "Two cities", "Release-ready"],
  },
  {
    id: "autism-documentary",
    title: "A Life, Overwhelmed — Documentary Short",
    category: "Video",
    location: "Wisconsin",
    year: "2026",
    image: "/assets/media/p-autism.jpg",
    video: "/assets/media/v-autism.mp4",
    poster: "/assets/media/p-autism.jpg",
    tags: ["S3 Films", "Documentary", "Vertical"],
    summary:
      "A front-facing documentary short: one client, one honest story about autism and feeling overwhelmed — told straight to camera.",
    challenge:
      "Hold a viewer through a deeply personal story with nothing but a face and the truth.",
    approach:
      "Front-facing documentary framing, patient pacing, and an edit that stays out of the way.",
    outcome:
      "A vertical story built to stop the scroll — and start conversations.",
    metrics: ["Documentary short", "Vertical format", "Story-first"],
  },
  {
    id: "lcc-vbs-recap",
    title: "LCC — Rize N Up VBS Recap",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-vbs.jpg",
    video: "/assets/media/v-vbs.mp4",
    poster: "/assets/media/p-vbs.jpg",
    tags: ["Event Recap", "Church", "Same-Week"],
    summary:
      "A recap film for Lighthouse Christian Church's Rize N Up VBS camp — a week of energy compressed into minutes.",
    challenge:
      "A week-long camp, hundreds of kids, and a church that wants families to feel the week again.",
    approach:
      "Daily coverage distilled into a single high-energy recap with the moments parents care about.",
    outcome:
      "A film the church shares with families — and uses to fill next year's camp.",
    metrics: ["Week-long coverage", "Recap film", "Community favorite"],
  },
  {
    id: "vendi-cards-brand",
    title: "VendiCards — Brand, Website & Marketing",
    category: "Branding",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-vendi-brand.jpg",
    video: "/assets/media/v-vendi-brand.mp4",
    poster: "/assets/media/p-vendi-brand.jpg",
    link: "https://vendicards.com/",
    tags: ["Full Brand Build", "Logo + Website", "Ongoing Marketing"],
    summary:
      "The entire VendiCards brand, built here: the identity, the logo, the website at vendicards.com, and the marketing behind their monthly card shows.",
    challenge:
      "A downtown card shop starting from zero — no brand, no website, no audience.",
    approach:
      "We created the complete brand and logo, designed and built vendicards.com, and keep the marketing engine running month after month.",
    outcome:
      "A full brand with a real online storefront and a growing monthly event — the whole lifecycle under one roof.",
    metrics: ["Brand + logo", "vendicards.com", "Ongoing marketing"],
  },
  {
    id: "argentum-cinema-ad",
    title: "Argentum ET Aurum — Cinema Ad",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-argentum.jpg",
    video: "/assets/media/v-argentum.mp4",
    poster: "/assets/media/p-argentum.jpg",
    tags: ["Commercial", "Cinema Ad", "30-Second Spot"],
    summary:
      "A 30-second theater pre-roll ad for Argentum ET Aurum, a downtown Fond du Lac store — playing before films at Odyssey Cinema.",
    challenge:
      "Thirty seconds on the big screen to make a local shop feel unmissable.",
    approach:
      "A cinematic 30-second spot built for the theater — bold visuals, tight pacing, clear call to action.",
    outcome:
      "Playing before movie previews at the local cinema, in front of a captive hometown audience.",
    metrics: ["30-second spot", "Theater placement", "Big-screen cut"],
  },
  {
    id: "real-estate-eagle-river",
    title: "Eagle River — Real Estate Highlight",
    category: "Video",
    location: "Eagle River, WI",
    year: "2026",
    image: "/assets/media/p-realestate.jpg",
    video: "/assets/media/v-realestate.mp4",
    poster: "/assets/media/p-realestate.jpg",
    tags: ["Real Estate", "Cinematic", "Property Film"],
    summary:
      "A cinematic property highlight filmed in Eagle River — the Northwoods, sold in two minutes.",
    challenge:
      "Make a property feel like a destination, not a listing.",
    approach:
      "Cinematic camera movement, golden-hour exteriors, and pacing built for buyers.",
    outcome:
      "A listing film that does the first showing before anyone drives up.",
    metrics: ["Cinematic highlight", "Northwoods location", "Listing-ready"],
  },
  {
    id: "kindly-human-story",
    title: "Kindly Human — Her Money Story",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-kindly.jpg",
    video: "/assets/media/v-kindly.mp4",
    poster: "/assets/media/p-kindly.jpg",
    tags: ["S3 Films", "Documentary", "Vertical"],
    summary:
      "A face-up-close documentary short for Kindly Human and Kindly Faith — one woman's finances story, told straight to camera.",
    challenge:
      "Make a vertical reel carry the weight of a full documentary.",
    approach:
      "Front-facing documentary framing, honest pacing, and an edit that lets the story breathe.",
    outcome:
      "A scroll-stopping story reel delivered for a contracted campaign.",
    metrics: ["Contracted campaign", "Vertical reel", "Documentary style"],
  },
  {
    id: "oshkosh-comedian",
    title: "Oshkosh's Funniest Comedian — Round 2",
    category: "Events",
    location: "Oshkosh, WI",
    year: "2026",
    image: "/assets/media/p-comedy.jpg",
    video: "/assets/media/v-comedy.mp4",
    poster: "/assets/media/p-comedy.jpg",
    tags: ["Event Recap", "Comedy", "Arena Show"],
    summary:
      "The round 2 recap of Oshkosh's Funniest Comedian — produced for Laughable Productions LLC, the Oshkosh Arena, and Venuworks.",
    challenge:
      "Compress a full night of stand-up into a recap that still lands the jokes.",
    approach:
      "Multi-angle coverage timed to the punchlines, cut with room to breathe.",
    outcome:
      "A recap the organizers use to sell out the next round.",
    metrics: ["Arena show", "Series recap", "Laughable Productions"],
  },
  {
    id: "bg-farmers-market",
    title: "BG at the Downtown FDL Farmers Market",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-farmers.jpg",
    video: "/assets/media/v-farmers.mp4",
    poster: "/assets/media/p-farmers.jpg",
    tags: ["S3 Films", "Highlights", "Community"],
    summary:
      "Big Guy Ben Giles reviews the downtown Fond du Lac farmers market — highlights, vendors, and the best bites.",
    challenge:
      "Capture a whole market morning as it happens — no staging, no script.",
    approach:
      "Run-and-gun coverage with personality-led hosting and quick-cut highlights.",
    outcome:
      "A community favorite that doubles as a love letter to downtown FDL.",
    metrics: ["Community highlight", "Same-week cut", "BG series"],
  },
  {
    id: "greene-county",
    title: "Greene County, Iowa — Community Highlight",
    category: "Video",
    location: "Greene County, IA",
    year: "2026",
    image: "/assets/media/p-greene.jpg",
    video: "/assets/media/v-greene.mp4",
    poster: "/assets/media/p-greene.jpg",
    tags: ["Community", "Tourism", "Cinematic"],
    summary:
      "A cinematic community highlight for Greene County, Iowa — small-town pride with big-screen treatment.",
    challenge:
      "Show a whole county's character in a single short film.",
    approach:
      "Location coverage across the county, cut to feel like an invitation.",
    outcome:
      "A highlight film the county can lead with anywhere.",
    metrics: ["County-wide", "Cinematic highlight", "Tourism-ready"],
  },
  {
    id: "lcc-vbs-full",
    title: "LCC — Rize N Up VBS: The Full Recap",
    category: "Video",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-vbs-full.jpg",
    video: "/assets/media/v-vbs-full.mp4",
    poster: "/assets/media/p-vbs-full.jpg",
    tags: ["Event Recap", "Church", "Feature Cut"],
    summary:
      "The full-length recap of Lighthouse Christian Church's Rize N Up VBS camp — the whole week, start to finish.",
    challenge:
      "A week-long camp deserves more than sixty seconds — the full story, without losing the energy.",
    approach:
      "The complete edit: every day, every stage moment, every kid's highlight in one feature recap.",
    outcome:
      "The definitive film of the week — the short cut teases it, this one tells it.",
    metrics: ["Full-length recap", "Week-long coverage", "Companion to the short cut"],
  },
  {
    id: "vendi-cards-show",
    title: "VendiCards Card Show — Event Promo",
    category: "Marketing",
    location: "Fond du Lac, WI",
    year: "2026",
    image: "/assets/media/p-vendi-show.jpg",
    video: "/assets/media/v-vendi-show.mp4",
    poster: "/assets/media/p-vendi-show.jpg",
    tags: ["Event Promo", "Monthly Event", "Social"],
    summary:
      "A promo video for VendiCards' monthly card show — built to fill seats on a repeating schedule.",
    challenge:
      "A monthly event needs fresh promotion every single month without starting from zero.",
    approach:
      "A repeatable promo format: fast, energetic, and easy to version for each show.",
    outcome:
      "A promo engine the shop runs monthly — consistent look, growing crowd.",
    metrics: ["Monthly format", "Repeatable", "Event turnout"],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "They rebuilt our brand, our website, and a year of content in one relationship. It stopped feeling like hiring vendors and started feeling like having a creative department.",
    name: "Dana R.",
    org: "Marketing Director, Meridian Health",
  },
  {
    quote:
      "Our livestream looked like a national broadcast. Sponsors saw it, and suddenly next year's budget conversation was easy.",
    name: "Kyle M.",
    org: "Director, Lakefront Sound Summit",
  },
  {
    quote:
      "We came in with an idea and a deadline. We left with a brand, a commercial, and a studio in our own office.",
    name: "Sam T.",
    org: "Founder, Copperline Coffee",
  },
];

export const TRUSTED_BY = [];

export const TRUSTED_LOGOS = [
  { name: "Record Entertainment Inc.", src: "/assets/logos/record-entertainment.png" },
  { name: "Laughable Productions", src: "/assets/logos/laughable.png" },
  { name: "Odyssey Cinemas", src: "/assets/logos/odyssey.png" },
  { name: "Operation Wisconsin", src: "/assets/logos/operation-wisconsin.png" },
  { name: "Kindly Human", src: "/assets/logos/kindly-human.png" },
  { name: "Blue Line Tavern", src: "/assets/logos/blue-line.png" },
  { name: "VendiCards", src: "/assets/logos/vendicards.png" },
  { name: "Fondy Famous", src: "/assets/logos/fondy-famous.png" },
  { name: "Accurate Controls", src: "/assets/logos/accurate-controls.png" },
  { name: "TechZz", src: "/assets/logos/techzz.png" },
  { name: "Downtown FDL Farmers Market", src: "/assets/logos/farmers-market.png" },
  { name: "Downtown FDL Partnership", src: "/assets/logos/downtown-fdl.png" },
  { name: "The Oshkosh Arena", src: "/assets/logos/oshkosh-arena.png" },
  { name: "NAMI Fond du Lac", src: "/assets/logos/nami-fdl.png" },
  { name: "Lighthouse Christian Church", src: "/assets/logos/lcc.png" },
  { name: "The Passenger Lounge", src: "/assets/logos/passenger-lounge.png" },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Listen & Strategy",
    copy: "We start with the outcome you need — sales, applicants, awareness, attendance — then design the creative backward from it.",
  },
  {
    num: "02",
    title: "Plan & Create",
    copy: "Strategy, scripts, identity, shot lists, site maps. Every decision gets made before production begins.",
  },
  {
    num: "03",
    title: "Produce & Capture",
    copy: "The right team for the project shows up prepared — commercial set, interview chair, or show day.",
  },
  {
    num: "04",
    title: "Launch & Grow",
    copy: "Edit, deliver, publish. Then the next month's content, the next campaign, the next chapter.",
  },
];
